import React from "react";
import OnboardingWizard from "../components/OnboardingWizard/OnboardingWizard";

const OnboardingWelcome: React.FC = () => {
  return <OnboardingWizard />;
};

export default OnboardingWelcome;
